import { Link } from 'react-router-dom';
import SafariDayTourImage from './assets/SafariTours.jpg';

function FullDaySafariPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage safari-day-hero">
        <div className="hero-content">
          <h1>Ebamba's Full Day Safari from Cape Town</h1>
          <p>Experience the thrill of African wildlife just a short drive from the city.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Your Gateway to the Big 5</h2>
          <div className="content-intro">
            <img src={SafariDayTourImage} alt="Full Day Safari" className="tour-main-image" />
            <p>Ebamba Travel & Tours brings you an exhilarating full-day safari experience, offering a chance to spot the iconic Big 5 – lion, leopard, elephant, rhino, and buffalo – in their natural habitat. Conveniently located just outside Cape Town, this tour is perfect for those looking for a wild adventure without an overnight stay.</p>
            <p>We partner with premier private game reserves like Aquila Private Game Reserve to ensure ethical wildlife encounters and comfortable, informative game drives. Prepare for a day filled with breathtaking scenery and unforgettable wildlife sightings.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Full Day Safari</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-car-alt"></i>
              <h4>Comfortable Transfer</h4>
              <p>Enjoy a scenic transfer from Cape Town in a luxury air-conditioned vehicle.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-binoculars"></i>
              <h4>Exciting Game Drives</h4>
              <p>Experience 2-3 hour guided game drives in open safari vehicles with expert rangers.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-paw"></i>
              <h4>Big 5 Sightings</h4>
              <p>Keep your eyes peeled for the Big 5 and a variety of other African wildlife.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-utensils"></i>
              <h4>Delicious Meals</h4>
              <p>Typically includes a welcome drink, buffet lunch, and opportunity for refreshments.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Travelers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"What an incredible day! We saw lions, rhinos, and elephants up close. Our Ebamba guide was fantastic, making the whole experience seamless and truly special."</p>
              <span>– David P. from Germany</span>
            </div>
            <div className="testimonial-card">
              <p>"A must-do when in Cape Town! The full-day safari arranged by Ebamba was perfect. The game reserve was beautiful, and the animals were amazing. Highly recommend!"</p>
              <span>– Sarah W. from Australia</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Safari Adventure</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FullDaySafariPage;
